"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePowerMonitorSystemHealth = exports.SystemHealthStatus = void 0;
const react_1 = require("react");
const Sensor_1 = require("../../types/Sensor");
const useSensorAlerts_1 = require("../useSensorAlerts");
const useSensors_1 = require("../useSensors");
var SystemHealthStatus;
(function (SystemHealthStatus) {
    SystemHealthStatus["Good"] = "good";
    SystemHealthStatus["Poor"] = "poor";
    SystemHealthStatus["Error"] = "error";
})(SystemHealthStatus = exports.SystemHealthStatus || (exports.SystemHealthStatus = {}));
function usePowerMonitorSystemHealth(selectedHubId) {
    const { sensors } = (0, useSensors_1.useSensors)(selectedHubId ?? undefined);
    const { fetchSensorAlerts } = (0, useSensorAlerts_1.useSensorAlerts)();
    const [status, setStatus] = (0, react_1.useState)(SystemHealthStatus.Good);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [timestamp, setTimestamp] = (0, react_1.useState)();
    const [alertCount, setAlertCount] = (0, react_1.useState)(0);
    const [isProcessing, setIsProcessing] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        const checkSystemHealth = async () => {
            // Prevent multiple simultaneous calls
            if (isProcessing) {
                return;
            }
            setIsProcessing(true);
            setLoading(true);
            const powerMonitor = sensors.find((sensor) => sensor.hubId === selectedHubId && sensor.type === Sensor_1.SensorType.POWER);
            if (!powerMonitor) {
                if (!cancelled) {
                    setStatus(SystemHealthStatus.Error);
                    setAlertCount(0);
                    setTimestamp(undefined);
                    setLoading(false);
                    setIsProcessing(false);
                }
                return;
            }
            // Convert to number and multiply by 1000 to get milliseconds, then create Date
            const timestampMs = powerMonitor.lastReported ? Number(powerMonitor.lastReported) * 1000 : 0;
            setTimestamp(timestampMs > 0 ? new Date(timestampMs) : undefined);
            try {
                const alerts = await fetchSensorAlerts(1, powerMonitor.id);
                if (!cancelled) {
                    setAlertCount(alerts.length);
                    setStatus(alerts.length === 0 ? SystemHealthStatus.Good : SystemHealthStatus.Error);
                    setLoading(false);
                    setIsProcessing(false);
                }
            }
            catch (error) {
                console.error('Error fetching sensor alerts for system health:', error);
                if (!cancelled) {
                    setStatus(SystemHealthStatus.Error);
                    setAlertCount(0);
                    setLoading(false);
                    setIsProcessing(false);
                }
            }
        };
        if (!selectedHubId) {
            setLoading(false);
            setStatus(SystemHealthStatus.Error);
            setAlertCount(0);
            setTimestamp(undefined);
            setIsProcessing(false);
        }
        else if (sensors.length > 0) {
            checkSystemHealth();
        }
        else {
            setLoading(true);
        }
        return () => {
            cancelled = true;
            setIsProcessing(false);
        };
    }, [sensors, selectedHubId]); // Removed fetchSensorAlerts from deps
    return { status, loading, timestamp, alertCount };
}
exports.usePowerMonitorSystemHealth = usePowerMonitorSystemHealth;
